<template>
	<div>
		<div class="login-page auth-pages" id="auth-page-loader">
			<Loader v-if="showLoader" />
			<template v-if="displayAuth">
				<div class="auth-close" @click="updatePopup">
					<img src="../assets/cancel.svg" alt="close"/>
				</div>
				<div class="left-banner-section"  v-if="displayValue">
					<div class="left-banner-images">
						<div class="section-holder">
							<div class="section-heading">
								<h3>Get access to everything WebMD offers</h3>
							</div>
							<div class="section-content">
								<ul>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-1.svg" alt="icon-1"/></span>
										<span class="list-text">Personalized tools for managing your health</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-2.svg" alt="icon-2"/></span>
										<span class="list-text">Health and wellness updates delivered to your inbox</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-3.svg" alt="icon-2"/></span>
										<span class="list-text">Saved articles, conditions and medications</span>
									</li>
									<li>
										<span class="list-icon"><img src="../assets/auth-icon-4.svg" alt="icon-4"/></span>
										<span class="list-text">Expert insights and patient stories</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div> 
				<div class="right-form-section"> 
					<div class="form-section">
						<div class="from-header">
							<h2>Log in to your WebMD account to save this article.</h2>
						</div>
						<div class="from-body">
							<form name="login" @submit.prevent="checkForm()">
								<div class="form-input-holder">
									<div class="form-input">
										<input type="text" id="email" name="email" autocomplete="off" :data-value="formData['email']" aria-labelledby="email" v-model='formData["email"]' @blur="inputCheck($event, 'email')" class="member-form-input email-input" :class="(this.emailError || this.emailFormateError) ? 'input-error' : ''"/>
										<label class="placeholder-text" for="email" id="placeholder-fname">
											<div class="text">Email</div>
										</label>
									</div>
									<div class="text-error" v-if="this.emailError">
										You need to enter your email.
									</div>
									<div class="text-error" v-if="this.emailFormateError">
										This email is invalid. Make sure it's written like example@email.com
									</div>
								</div>
								<div class="form-input-holder">
									<div class="form-input">
										<div class="show-password" data-type='show' @click="ShowPassword">
											{{(this.showpassword==false) ? 'Show' : 'Hide'}}
										</div>
										<input type="password" id="password" name="password" autocomplete="off" :data-value="formData['password']" aria-labelledby="password" v-model='formData["password"]' @blur="inputCheck($event, 'password')" class="member-form-input password-input"  :class="(this.passwordError) ? 'input-error' : ''"/>
										<label class="placeholder-text" for="email" id="placeholder-fname">
											<div class="text">Password</div>
										</label>
									</div>
									<div class="text-error" v-if="this.passwordError">
										You need to enter your password.
									</div>
									<div class="text-error" v-if="this.combinationError" v-html="this.combinationError"></div>
								</div>
								<div class="form-input-holder form-text-holder">
									<div class="form-text">
										<a :href="encryptData()" @click="omCall()">Forgot password?</a>
									</div>
									<div class="form-checkbox">
										
										<div class="form-checkbox-holder">
											<div class="form-checkbox-content">
												<input type='checkbox' id="rememberme" value="1" v-model="rememberme" class="remember-me" />  
												<span class="checkmark" for="rememberme" @click="udpateCheckbox"></span>
											</div>
											<div class="form-checkbox-content">
												<label for="rememberme">Remember me</label>
											</div>
										</div>
										<div class="form-checkbox-holder"></div>
									 	
									</div>
								</div>
								<div class="form-button">
									<Button type="primary" size="large" :stretch="true" @click="Submit()">Log In</Button>
								</div>
								<div class="form-account">
									<p>Don't have an account? <a  @click="popupAction('reg-login', displayValue, isMobileDisplay)">Sign Up </a></p>
								</div>
							</form>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="right-form-section"> 
					<div class="form-section">
						Article Saved Successfully
					</div>
				</div>
			</template>
			<ConfirmationOverlay
				v-if="displayPopup"
				pageName="login"
				:popupType="popupType"
				:displayPopup="displayPopup"
				:userEmail="formData.email"
				:userId="userId"
				:savedAccessToken="savedAccessToken"
				:contentData="contentData"
				:savedDrugs="savedDrugs"
				@updateDisplay="updateDisplay"
				@updateAction="updateSavePopup"
				@saveSuccess="toggleNotification"
				@closeAuthPopup="updatePopup"
			/>
		</div>
	</div>
</template>
<script>
import { Button } from 'webmd-elements';
import axios from 'axios';
import registrationMixins from './mixins/registration.mixins.es6';
import commonapiMixins from './mixins/commonapi.mixins.es6';
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import emitter from 'tiny-emitter/instance';
import Loader from './Loader.vue';
import api from '../api.es6';
export default {
	components:{
		Button,
		Loader,
		ConfirmationOverlay
	},
	props:{
		displayMainConfPopup : Boolean,
		savedAccessToken : String,
		parentUserId: String,
		parentEmailId: String,
		displayValue : Boolean,
		contentData:Object,
		savedDrugs:Object,
		isMobileDisplay: Boolean,
	},
	data() {
		return {
			displayAuth : true, 
			showLoader : false,
			formData:{
				email : '',
				password: ''
			},
			popupType : 'soft',
			displayPopup : false,
			searchterm : '',
			email : '',
			password:'',
			emailError: false,
			passwordError: false,
			showpassword : false,
			emailFormateError: false,
			formIsValid : true,
			combinationError: '',
			rememberme: false,
			userId: '',
			successMsg: '',
			errorEmailMsg: false
		};
	},
	emits: ['updateAuthpopupComponent', 'updateAction', 'saveSuccess'],
	mixins: [registrationMixins, commonapiMixins],
	computed: {
		Button
	},
	watch: {
		savedAccessToken() {
			this.userId = this.parentUserId;
			this.formData.email = this.parentEmailId;
			this.displayPopup = true;
			this.displayAuth = true
		},
	},
	mounted(){
		if(this.savedAccessToken){
			this.userId = this.parentUserId;
			this.formData.email = this.parentEmailId;
			this.displayPopup = true;
			this.displayAuth = true
		}
	},
	methods:{
		updatePopup(){
			this.$emit('updateAuthpopupComponent', false)
		},
		updateSavePopup(){
			this.$emit('updateAction', 'save')
		},
		udpateCheckbox(){
			let checkBoxValue = (document.getElementById("rememberme").checked) ? false : true;
			document.getElementById("rememberme").checked = checkBoxValue;
			this.rememberme = checkBoxValue;
		},
		updateDisplay(displayPopup){
			if(this.savedAccessToken){
				this.updatePopup();
				this.displayPopup = displayPopup;
			}
			else{
				this.displayPopup = displayPopup;
			}
		},
		toggleNotification(flag) {
			this.$emit('saveSuccess', flag);
		},
		inputCheck(event, modalValue){
			let checkValidation = []
			checkValidation = Object.keys(this.formData).map((key, index) => {
				if(key){
					this.combinationError = '';
				}
				if(key=='email' && modalValue==key){
					if(this.formData[key]){
						let checkValidationEmail = String(this.formData[key]).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
						if(!checkValidationEmail){
							this.emailFormateError = true
							this.emailError = false
							this.$vwmdTrack({ sSource: `reg-error_1`});
							return false
						}
						else{
							this.emailFormateError = false
							this.emailError = false
							return true
						}
					}
					else{
						this.emailError = true
						this.emailFormateError = false
						this.$vwmdTrack({ sSource: `reg-error_1`});
						return false
					}
				}
				if(key=="password" && modalValue==key){
					if(this.formData[key]){
						this.passwordError = false
						return true
					}
					else{
						this.passwordError = true
						this.$vwmdTrack({ sSource: `reg-error_2`});
						return false
					}

				}
				if(event){
					if(key=='email'){
						if((this.formData[key]!='' &&  this.formData[key]!=0)){
							let checkValidationEmail = String(this.formData[key]).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
							if(!checkValidationEmail){
								return false
							}
						}
						else{
							return false
						}
					}
					else{
						return (this.formData[key]!='' &&  this.formData[key]!=0);
					}
				}
			})
			this.formIsValid = (checkValidation.includes(false)) ? false : true;
		},
		encryptData(){
			if(!this.formData.email){
				return this.updateUrl('/password-reset');
			}
			else{
				return 	this.updateUrl('/password-reset',encodeURIComponent(btoa(this.formData.email)))
			}
		},
		omCall() {
			this.$vwmdPageLink({moduleName: `reg-login-lnk2_fgpsw2`});
		},
		ShowPassword(){
			let checkPassword = document.getElementById('password');
			if(checkPassword){
				checkPassword.type = (this.showpassword==true) ? 'password' : 'text'
				this.showpassword = !this.showpassword;
			}
		},
		Submit () {
			const params = new URLSearchParams();
			params.append('username', this.formData.email);
			params.append('password', this.formData.password);
			params.append('remember', (this.rememberme==true) ? 1 : 0);
			params.append('getcookie', true);
			const query = '/api/reg/regapi.svc/secure/json/login';
			if(this.formData.email && this.formData.password){
				let searchapi = this.checkUrl('www',query);
				this.showLoader = true;
				api.getHeaders().then(headers => axios.post(`${searchapi}`, params, headers,{
					'Content-Type': 'application/x-www-form-urlencoded'})).then((response) => {
					if (response && response.data.d.code === 1) {
						let webmdAuthp = this.getCookie('ab');
						if(this.isMobileDisplay){
							this.$vwmdPageLink(null, {
								metrics: {
									'wb.mlink': 'login2',
									'wb.mmodule': 'reg-login-suc2'
								}
							})
						}
						else if(webmdAuthp){
							this.$vwmdPageLink(null, {
								metrics: {
									'wb.mlink': (this.displayValue) ? 'login2b' : 'login2a',
									'wb.mmodule': (this.displayValue) ? 'reg-login-suc2b' : 'reg-login-suc2a'
								}
							});
						}
						else{
							this.$vwmdPageLink(null, {
								metrics: {
									'wb.mlink': 'login2',
									'wb.mmodule': 'reg-login-suc2'
								}
							});
						}
						const authCode = response.data.d.data.authcode;
						const regCookies = response.data.d.data.cookies;
						regCookies.map((testVal, index)=> {
							document.cookie = `${testVal.Name}=${testVal.Value}; expires=${testVal.Expires}; path=/; domain=.webmd.com; SameSite=${testVal.SameSite}; Secure=${testVal.Secure}`;
							if(index+1 == regCookies.length){
								if(authCode){
									document.cookie = `WBMD_AUTHC=${authCode}; expires=${testVal.Expires}; path=/; domain=.webmd.com; SameSite=${testVal.SameSite}; Secure=${testVal.Secure}`;
									document.cookie = `WBMD_NWEUS=${response.data.d.data.isnewuser}; expires=${testVal.Expires}; path=/; domain=.webmd.com; SameSite=${testVal.SameSite}; Secure=${testVal.Secure}`;
									document.cookie = `WBMD_REM=${(this.rememberme==true) ? 1 : 0}; expires=${testVal.Expires}; path=/; domain=.webmd.com; SameSite=${testVal.SameSite}; Secure=${testVal.Secure}`;
								}
							}
						})
						this.userId = response.data.d.data.userid;
						if(response.data.d.data.emailverified === false) {
							this.popupType =  (response.data.d.data.isnewuser==true) ? 'hard' : 'soft'
							this.displayPopup = true
							this.showLoader = false;
						}
						else {
							this.getToken(authCode)
						}
						emitter.emit('check-log-in', {
							isSave: true
						});
					} 
					else {
						const updatedMsg = response?.data?.d?.data?.msg;
						const updateMsgCode = response?.data?.d?.code;
						if(this.regErrorMessage(updateMsgCode, this.formData.email)){
							this.combinationError = this.regErrorMessage(updateMsgCode, this.formData.email);
							this.$vwmdTrack({ sSource: `reg-error_24`});
						}
						else if(this.regErrorMessage(updatedMsg, this.formData.email)){
							this.combinationError = this.regErrorMessage(updatedMsg, this.formData.email);
							this.$vwmdTrack({ sSource: `reg-error_24`});
						}
						else{
							this.combinationError = `<span>${updatedMsg.replace(/username/g, 'email').concat('. Try again.')}</span>`;
							this.$vwmdTrack({ sSource: `reg-error_24`});
						}
						this.showLoader = false;
					}
				}).catch(() => {
					this.showLoader = false;
				});
			}
			else{
				this.combinationError = `<span>You need to enter your email / password.</span>`;
				this.$vwmdTrack({ sSource: `reg-error_24`});
			}
		},
		getToken(authCode){
			let query = '/oauth2api.svc/token';
			let finalUrl = this.checkUrl('oauthapi',query);
			if(finalUrl){
				this.showLoader = true;
				api.getTokenHeaders().then(headers =>{
					const params = new URLSearchParams();
					params.append('grant_type', 'authorization_code');
					params.append('client_id', headers.headers.client_id);
					params.append('client_secret', headers.headers.client_secret);
					params.append('code', authCode);
					params.append('long_live_token', this.rememberme==true ? true : false);
					return  axios.post(`${finalUrl}`, params, {'Content-Type':'application/x-www-form-urlencoded'})}).then(async(response) => {
					if(response.data && response.data.error==null){
						let date = new Date();
						date.setSeconds(response.data.expires_in);
						document.cookie = `WBMD_AUTHP=${response.data.access_token}; expires=${date.toUTCString()}; path=/; domain=.webmd.com; SameSite=None; Secure=true`;
						let checkSave = await this.saveAfterAuth(response.data.access_token, 'save', this.contentData, this.savedDrugs);
						if(checkSave && checkSave.data){
							this.$emit('updateAction', 'save');
							this.$emit('saveSuccess', true);
						}
					}
				}).catch((error) => {
					this.showLoader = false;
				});
			}
		},
	}
};
</script>
<style scoped lang="scss">
.login-page{
    .right-form-section{
		padding: 117px 0px 118px 0px;
		@media(max-width:992px) and (min-width:768px){
			padding: 0px 20px;
			margin:66px 0 20px 0;
		}
		@media(max-width:767px){
			padding: 0px 20px;
			margin:66px 0 20px 0;
		}
        .from-body{
			h2{
				margin-bottom: 24px;
			}
            .form-input-holder{
                &:nth-child(2){
                    margin-top: 24px;
                }
            }
        }
		.form-agree{
			font-size: 14px;
			line-height: 20.11px;
			color: #1b1b1b;
		}
		
    }
}
</style>